import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { ITransaction } from "../interface/ITransactionHistory";
import { DetailsLayout } from "./DetailsLayout";
import { useGetPaymentDetails } from "./hook/useGetPaymentDetails";

interface IParams {
    paymentCorrelationTransactionUuid: ITransaction["paymentCorrelationTransactionUuid"];
    month: number;
}

export const PaymentDetails = (props: IParams) => {
    const { paymentCorrelationTransactionUuid, month } = props;
    const {
        paymentDetails,
        getPaymentDetailsState: { error, isLoading },
    } = useGetPaymentDetails(paymentCorrelationTransactionUuid, month);
    const { t } = useTranslation("payment");

    return (
        <DetailsLayout error={error} hasDetails={Boolean(paymentDetails)} isLoading={isLoading}>
            {paymentDetails && (
                <Fragment>
                    {/* <Grid item xs={12}>
                        <Typography>
                            <Trans
                                i18nKey="paymentDetailsText"
                                ns="payment"
                                values={{
                                    partialDigits: paymentDetails.paymentMethod.partialDigits,
                                    paymentDatetime: formatDateTime(paymentDetails.paymentDatetime).toLocaleLowerCase(),
                                }}
                            />
                        </Typography>
                        <Typography color="secondary" variant="body2">
                            {t("generatedFrom")}&nbsp;
                            {paymentDetails.paymentRunId ? t("paymentRun") : t("oneOffPayment")}
                        </Typography>
                    </Grid> */}
                    {paymentDetails.comment && (
                        <Grid item xs={12}>
                            <Typography color="primary">{t("details")}</Typography>
                            <Typography>{paymentDetails.comment}</Typography>
                        </Grid>
                    )}
                </Fragment>
            )}
        </DetailsLayout>
    );
};
